import strings from 'strings';
import {
  OtherFileCategoryId,
  PortfolioFileCategoryId,
  ResumeFileCategoryId
} from 'UI/components/organisms/sendouts/utils';

const { attachments: STRINGS } = strings.sendoutsV2.form.sections;

export const PROCESS_TYPE = {
  Sendout: {
    title: 'Sendout',
    id: 1
  },
  Sendover: {
    title: 'Sendover',
    id: 2
  }
};

export const INTERVIEW_CALL_TYPES = {
  Preparation: 'preparation',
  Debriefing: 'debriefing'
};

export const INTERVIEW_REMINDERS_STATUS = {
  Enabled: 'Enabled',
  Disabled: 'Disabled'
};

export const INTERVIEW_CALL_TITLE_BY_TYPE = {
  [INTERVIEW_CALL_TYPES.Preparation]:
    strings.sendoutsV2.drawers.sendoutInterviewDetails.tabs.preparationCall.title,
  [INTERVIEW_CALL_TYPES.Debriefing]:
    strings.sendoutsV2.drawers.sendoutInterviewDetails.tabs.debriefingCall.title
};

export const ATTACHMENTS_CATEGORIES = {
  resume: {
    id: ResumeFileCategoryId,
    title: STRINGS.categories.resume,
    required: false,
    multiple: true
  },
  portfolio: {
    id: PortfolioFileCategoryId,
    title: STRINGS.categories.portfolio,
    required: false,
    multiple: true
  },
  other: {
    id: OtherFileCategoryId,
    title: STRINGS.categories.otherFiles,
    required: false,
    multiple: true
  }
};
